import { useRef, useEffect } from 'react';
import { shallowEqual } from './shallowEqual.js';

function useShallowStableValue(value) {
  const cache = useRef(value);
  useEffect(() => {
    if (!shallowEqual(cache.current, value)) {
      cache.current = value;
    }
  }, [value]);
  return shallowEqual(cache.current, value) ? cache.current : value;
}

export { useShallowStableValue };
//# sourceMappingURL=useShallowStableValue.js.map
